<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection>
          <div class="text-right">
            <argon-button :to="{ name: 'Create Jabatan' }" :isRouteLink="true"><font-awesome-icon icon="fa-solid fa-plus" /> Buat Baru</argon-button>
          </div>
        </MetaSection>
      </GridCol>
      <GridCol :size="12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="7">
                <div class="d-flex align-items-center justify-content-start gap-2">
                  <div class="d-flex justify-content-start w-100 gap-2">
                    <InputGroup class="m-0 filter">
                      <template v-slot:prepend>
                        <i class="fas fa-search" aria-hidden="true"></i>
                      </template>
                      <input v-model="params.keyword" @keyup="getData(params.keyword)" type="text" class="form-control"
                        placeholder="Cari nama jabatan" style="border-right: 1px solid #d2d6da!important;">
                    </InputGroup>
  
                    <FormGroup class="m-0 filter">
                      <model-list-select
                        class="form-control"
                        v-model="params.unitkerja_id"
                        :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                        option-value="id"
                        option-text="name"
                        placeholder="Semua Unit Kerja"
                      />
                    </FormGroup>

                    <FormGroup class="m-0 filter">
                      <model-list-select
                        class="form-control"
                        v-model="params.status"
                        :list="[{text: 'Aktif', value: 1}, {text: 'Non Aktif', value: 0}]"
                        option-value="value"
                        option-text="text"
                        placeholder="Semua Status"
                      />
                    </FormGroup>
                  </div>
                </div>
              </GridCol>
            </GridRow>
          </template>
          <ListView>
            <template v-slot:thead>
              <tr>
                <th scope="col" colspan="3"></th>
                <th scope="col" colspan="2" class="text-center">Kompetensi</th>
                <th scope="col" colspan="2" class="text-center">Bobot</th>
                <th scope="col" colspan="2"></th>
              </tr>
              <tr>
                <th scope="col">Kode</th>
                <th scope="col">Jabatan</th>
                <th scope="col">Unit Kerja</th>
                <th scope="col" class="text-center">Inti</th>
                <th scope="col" class="text-center">Manajerial</th>
                <th scope="col" class="text-center">Capaian Kinerja</th>
                <th scope="col" class="text-center">Kompetensi</th>
                <th scope="col">status</th>
                <th scope="col">Aksi</th>
              </tr>
            </template>
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="7" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ item.code || "-" }}</td>
                <td class="font-weight-bold">{{ item.name ?? "" }}</td>
                <td>{{ item.unitkerja?.name ?? "" }}</td>
                <td class="text-center">{{ item?.inti || 0 }}</td>
                <td class="text-center">{{ item?.manajerial || 0 }}</td>
                <td class="text-center">{{ item?.bobot_capaian_kinerja || '-' }}</td>
                <td class="text-center">{{ item?.bobot_kompetensi || '-' }}</td>
                <td>
                  <argon-badge v-if="item.status == 1" color="success">Aktif</argon-badge>
                  <argon-badge v-if="item.status == 0" color="danger">Non Aktif</argon-badge>
                </td>
                <td class="align-middle">
                  <ThreeDotsMenu>
                    <router-link :to="{ name: 'Update Jabatan', params: { id: item?.id ?? 0 } }"
                                 class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                                 data-original-title="Edit user">Edit</router-link>
                    <button @click.prevent="deleteData(item.id)"
                            class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                            data-original-title="Delete user">Hapus</button>
                  </ThreeDotsMenu>
                </td>
              </tr>
            </template>
            <ArgonPagination :page="params.page" :total_page="metaData.total_page" :current_page="metaData.current_page" @changepage="changePage" @changelimit="changeLimit" />
          </ListView>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import JabatanApi from '@/repository/api/JabatanApi';
import ArgonBadge from '@/components/ArgonBadge.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import ListView from '@/components/ListView.vue';
import FormGroup from '@/components/FormGroup.vue';
import ArgonPagination from '@/components/ArgonPagination.vue';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "tables",
  components: {
    ArgonButton,
    CardComponent,
    InputGroup,
    ArgonBadge,
    ThreeDotsMenu,
    MetaSection,
    GridRow,
    GridCol,
    ListView,
    FormGroup,
    ArgonPagination,
    ModelListSelect,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      unitkerja: [],
      params: {
        limit: "",
        jabatan_id: "",
        unitkerja_id: "",
        status: "",
        keyword: "",
        page: 1,
      },
      metaData: {}
    };
  },
  async mounted() {
    await this.getData();
    await this.getUnitKerja();
  },
  watch: {
    'params.status': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.unitkerja_id': {
      handler: async function () {
        this.getData();
      }
    },
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          // await this.getJabatan();
          await this.getData();
        }
      },
      deep: false,
    },
  },
  methods: {
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.getbyparam({page: "all", status: "active"}).then((response) => {
        this.unitkerja = response.data;
      }).catch(() => {
        this.unitkerja = [];
      });
      this.$store.state.loading = false;
    },
    async getData(keyword = "") {
      clearTimeout(this.timer)
      if (keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await this.getDataAll();
        }, 1500)
      }
    },
    async getDataAll() {
      let params = {}
      Object.keys(this.params).forEach(key => {
        if (!(this.params[key] === undefined || this.params[key] === null || this.params[key] === "")) {
          params[key] = this.params[key];
        }
      });
      this.$store.state.loading = true;
      await JabatanApi.getbyparam(params).then((response) => {
        this.data = response.data;
        this.metaData = {
          status: response?.status ?? null,
          message: response?.message ?? null,
          total_item: response?.total_item ?? null,
          per_page: response?.per_page ?? null,
          total_page: response?.total_page ?? null,
          current_page: response?.current_page ?? null,
        }
      }).catch((error) => {
        if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          this.params.page = this.params.page - 1;
        }
        this.metaData = {};
        this.data = [];
      });
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await JabatanApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error?.response?.data?.message ?? "Data tidak dapat dihapus",
            });
          });
          this.$store.state.loading = false;
        }
      })
    }
  },
};
</script>
